import metadata from "$public/metadata.json";
import { capitalize } from "$utils/capitalize";
export const challengeTypeChoices = metadata.Challenge.type.type.map((id) => ({
    id,
    name: capitalize(id).replaceAll("_", " ")
}));
